import script from "./PatientProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientProfile.vue?vue&type=script&setup=true&lang=js"

import "./PatientProfile.vue?vue&type=style&index=0&id=18b89b73&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18b89b73"]])

export default __exports__